import { lazily } from 'react-lazily'
import { LazyRouteModel } from '../model/Route'
import { PlatformPage } from '../../e-learning/page/PlatformPage'
import { PlatformArticlePage } from '../../e-learning/page/PlatformArticlePage'
import { VillkorPage } from '../../villkor/page/VillkorPage'
import { LearningOverviewPage } from 'src/feature/e-learning/page/LearningOverviewPage'
import { LearningCategoryPage } from 'src/feature/e-learning/page/LearningCategoryPage'
import { MyCoursesPage } from 'src/feature/e-learning/page/MyCoursesPage'
import { SkillAnalysisPage } from 'src/feature/skill-assessment/page/SkillAssessmentPage'
import { UserDashboardPage } from 'src/feature/dashboard/page/UserDashboardPage'
import { MyTeamLearningPage } from 'src/feature/my-team/page/MyTeamLearningPage'
import { MyTeamPerformancePage } from 'src/feature/my-team/page/MyTeamPerformancePage'
import { MyTeamPerformanceCreatePage } from 'src/feature/my-team/page/MyTeamPerformanceCreatePage'
import { MyTeamSkillGapsPage } from 'src/feature/my-team/page/MyTeamSkillGapsPage'
import { MyTeamPage } from 'src/feature/my-team/page/MyTeamPage'
import { NotFoundRolesPage } from 'src/feature/my-team/page/NotFoundRolesPage'
import { UserDetailsNotFoundPage } from 'src/feature/dashboard/page/UserDetailsNotFoundPage'
import { MyTeamDashboard } from 'src/feature/my-team/page/MyTeamDashboard'
import { CreateProjectBuilderPage } from 'src/feature/project-builder/page/CreateProjectBuilderPage'
import { ProjectBuilderOverviewPage } from 'src/feature/project-builder/page/OverviewProjectBuilderPage'

const { BlogPage } = lazily(() => import('src/feature/blog/page/BlogPage'))
const { BlogArticlePage } = lazily(() => import('src/feature/blog/page/BlogArticlePage'))
const { ForumPage } = lazily(() => import('src/feature/forum/page/ForumPage'))
const { MaintenancePage } = lazily(() => import('src/feature/maintenance/page/MaintenancePage'))
const { PayrollPage } = lazily(() => import('src/feature/payroll/page/PayrollPage'))
const { FaqPage } = lazily(() => import('src/feature/knowledge/page/FaqPage'))
const { FaqGroupPage } = lazily(() => import('src/feature/knowledge/page/FaqGroupPage'))
const { AdditionalServicesPage } = lazily(() => import('src/feature/knowledge/page/AdditionalServicesPage'))
const { ProfileInfoPage } = lazily(() => import('src/feature/profile/page/ProfileInfoPage'))
const { SubscriptionPage } = lazily(() => import('src/feature/profile/page/SubscriptionPage'))
const { PaymentHistoryPage } = lazily(() => import('src/feature/payment/page/PaymentHistoryPage'))
const { SignUpPage } = lazily(() => import('src/feature/on-boarding/page/SignUpPage'))
const { CompanySignUpPage } = lazily(() => import('src/feature/on-boarding/page/CompanySignUpPage'))
const { AuthHomePage } = lazily(() => import('src/feature/auth/page/AuthHomePage'))
const { SignInPage } = lazily(() => import('src/feature/auth/page/SignInPage'))
const { ForgotPasswordPage } = lazily(() => import('src/feature/auth/page/ForgotPasswordPage'))
const { ResetPasswordPage } = lazily(() => import('src/feature/auth/page/ResetPasswordPage'))
const { VerifyEmailPage } = lazily(() => import('src/feature/auth/page/VerifyEmailPage'))
const { SsoVerifyPage } = lazily(() => import('src/feature/auth/page/SsoVerifyPage'))
const { ActivateLearningPage } = lazily(() => import('src/feature/stripe/page/ActivateLearningPage'))
const { LoginPage } = lazily(() => import('src/feature/b2b/page/LoginPage'))
const { UsersPage } = lazily(() => import('src/feature/control-panel/page/UsersPage'))
const { OrganisationPage } = lazily(() => import('src/feature/control-panel/page/OrganisationPage'))
const { ModulesPage } = lazily(() => import('src/feature/control-panel/page/ModulesPage'))
const { SystemPage } = lazily(() => import('src/feature/control-panel/page/SystemPage'))
const { EditProfilePage } = lazily(() => import('src/feature/profile/page/EditProfilePage'))
const { EditPositionsPage } = lazily(() => import('src/feature/profile/page/EditPositionsPage'))
const { CoursePlayerPage } = lazily(() => import('src/feature/e-learning/page/CoursePlayerPage'))
const { CompanyPage } = lazily(() => import('src/feature/company-page/page/CompanyPage'))
const { CompanyPageEditItem } = lazily(() => import('src/feature/company-page/page/CompanyPageEditItem'))

export const lazyRoutes: LazyRouteModel = {
  // auth
  authHome: <AuthHomePage />,
  signIn: <SignInPage />,
  forgotPassword: <ForgotPasswordPage />,
  resetPassword: <ResetPasswordPage />,
  villkor: <VillkorPage />,
  verifyAccount: <VerifyEmailPage />,
  ssoVerify: <SsoVerifyPage />,

  // on-boarding
  signUp: <SignUpPage />,
  companySignUp: <CompanySignUpPage />,

  // blog
  blog: <BlogPage />,
  blogArticle: <BlogArticlePage />,

  // eLearning
  eLearning: <PlatformPage />,
  platformArticle: <PlatformArticlePage />,
  learning: <LearningOverviewPage />,
  learningCategory: <LearningCategoryPage />,
  course: <CoursePlayerPage />,
  myCourses: <MyCoursesPage />,

  // knowledge
  faq: <FaqPage />,
  faqGroup: <FaqGroupPage />,
  additionalServices: <AdditionalServicesPage />,

  // payroll
  payroll: <PayrollPage />,

  // forum
  forum: <ForumPage />,

  // profile
  profileInfo: <ProfileInfoPage />,
  editProfile: <EditProfilePage />,
  editPositions: <EditPositionsPage />,
  subscription: <SubscriptionPage />,
  paymentHistory: <PaymentHistoryPage />,
  activateLearning: <ActivateLearningPage />,

  // maintenance
  maintenance: <MaintenancePage />,

  // B2B
  login: <LoginPage />,
  controlpanelUsers: <UsersPage />,
  controlpanelModules: <ModulesPage />,
  controlpanelSystem: <SystemPage />,
  controlpanelOrganisation: <OrganisationPage />,

  // CompanyPage
  companyPage: <CompanyPage />,
  companyPageEditItem: <CompanyPageEditItem />,

  // skill analysis
  skillAssessment: <SkillAnalysisPage />,

  // dashboard
  userDashboard: <UserDashboardPage />,

  // my team
  myTeam: <MyTeamPage />,
  myTeamRoles: <NotFoundRolesPage />,
  MyTeamUserDetails: <UserDetailsNotFoundPage />,
  myTeamDashboard: <MyTeamDashboard />,
  myTeamLearning: <MyTeamLearningPage />,
  myTeamPerformance: <MyTeamPerformancePage />,
  myTeamPerformanceCreate: <MyTeamPerformanceCreatePage />,
  myTeamSkillGaps: <MyTeamSkillGapsPage />,

  // project builder
  projectBuilder: <ProjectBuilderOverviewPage />,
  projectBuilderCreate: <CreateProjectBuilderPage />,
} as const
